<template>
  <div
    class="tw:bottom-0 tw:border-t tw:border-gray-300 tw:px-6 tw:py-4 tw:flex tw:flex-col tw:md:flex-row tw:justify-between tw:gap-y-4"
  >
    <GhostButton
      class="tw:flex"
      @click="onBackAction"
      :disabled="rcCampaignCreationInProgress"
      dataTestId="rc-onboarding-setup-footer-back-button"
    >
      <span class="tw:mx-auto tw:flex tw:items-center tw:gap-x-3 tw:text-center">
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 1L1 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <path d="M6 11L1 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        {{ $t('back_cta') }}</span
      >
    </GhostButton>

    <MainButton
      v-if="currentStep === 3"
      class="tw:flex tw:items-center tw:gap-x-3"
      @click="emit('onStartCampaign')"
      :disabled="!paymentEnabled || rcCampaignCreationInProgress"
      dataTestId="rc-onboarding-setup-footer-create-campaign-button"
    >
      <SmallDotLoader color="#fff" v-if="rcCampaignCreationInProgress" />
      <span v-else class="tw:mx-auto">{{ $t('check_out_page_rc_cta') }}</span>
    </MainButton>
    <MainButton v-else class="tw:flex" @click="onNextAction" dataTestId="rc-onboarding-setup-footer-next-button">
      <span class="tw:mx-auto tw:flex tw:items-center tw:gap-x-3"
        >{{ $t('tbs_modal_next') }}
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <path d="M1 11L6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </span>
    </MainButton>
  </div>
</template>

<script setup>
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'

import { useSetup } from './useSetup'

defineProps({
  paymentEnabled: {
    type: Boolean,
    default: false,
  },
  rcCampaignCreationInProgress: {
    type: Boolean,
    default: false,
  },
})

const { currentStep } = useSetup()
const emit = defineEmits(['onNext', 'onBack', 'onStartCampaign'])
const onBackAction = () => emit('onBack')
const onNextAction = () => emit('onNext')
</script>
